function isAddButton(button) {
  if (button.classList.contains('repeat-add-button')) return true
  if (!button.closest('.nested-head')) return false

  const label = [button.textContent, button.title, button.getAttribute('aria-label')]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

  return label.includes('добав')
}

function sectionFor(button) {
  return button.closest('.editor-section, .field-group, .nested-group')
}

function scrollToNewCard(section, knownCards) {
  const addedCard = Array.from(section.querySelectorAll('.repeat-card'))
    .find(card => !knownCards.has(card))

  if (!addedCard) return false

  requestAnimationFrame(() => {
    addedCard.scrollIntoView({ behavior: 'smooth', block: 'start' })
  })

  return true
}

export default {
  install() {
    document.addEventListener('click', event => {
      const button = event.target.closest('button')
      if (!button || button.disabled || !isAddButton(button)) return

      const section = sectionFor(button)
      if (!section) return

      const knownCards = new Set(section.querySelectorAll('.repeat-card'))
      let observer = null
      let timeout = null

      const finish = () => {
        if (observer) observer.disconnect()
        if (timeout) window.clearTimeout(timeout)
      }

      const checkForNewCard = () => {
        if (!scrollToNewCard(section, knownCards)) return
        finish()
      }

      observer = new MutationObserver(checkForNewCard)
      observer.observe(section, { childList: true, subtree: true })

      requestAnimationFrame(() => {
        requestAnimationFrame(checkForNewCard)
      })

      timeout = window.setTimeout(finish, 1200)
    }, true)
  }
}
